export default __webpack_public_path__ + "static/media/dashboardActive.848b6940.svg";